import React from "react";
import { Link } from "react-router-dom";

import breadcrumbBG from "../../assets/img/aniamtion-sea.png";
import shapeImg1 from "../../assets/img/animation/1.png";
import shapeImg2 from "../../assets/img/animation/2.png";
import shapeImg3 from "../../assets/img/animation/3.png";

const Breadcrumb = ({ itemClass, title, subtitle }) => {
  const breadcrumbStyles = `
  @keyframes floatHorizontal {
  0% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(15px); /* right */
  }
  50% {
    transform: translateX(0px); /* back to center */
  }
  75% {
    transform: translateX(-15px); /* left */
  }
  100% {
    transform: translateX(0px);
  }
}

.animated-shape-2 {
  animation: floatHorizontal 4s ease-in-out infinite;
}

  `;

  return (
    <>
      <style>{breadcrumbStyles}</style>
      <div
        className={
          itemClass
            ? itemClass
            : "it-breadcrumb-area fix it-breadcrumb-bg p-relative"
        }
        style={{
          backgroundImage: `url(${breadcrumbBG})`,
          backgroundSize: "110% 130px", // Stretch the image horizontally, fixed vertical height
          backgroundRepeat: "no-repeat", // No repetition, so borders aren't duplicated
          backgroundPosition: "bottom center", // Align image bottom and center
          minHeight: "130px",
          width: "100vw", // Ensures container is full screen width
          overflow: "hidden", // Prevents scrollbars from excess image
        }}
      >
        {/* Shapes */}
        {/* <div className="it-breadcrumb-shape-1 d-none d-md-block">
          <img
            src={shapeImg1}
            alt=""
            style={{ width: "80px", height: "auto" }}
          />
        </div> */}

        {/* Shape 2 with floating animation */}
        {/* <div className="it-breadcrumb-shape-2 animated-shape-2 d-none d-md-block">
          <img
            src={shapeImg2}
            alt=""
            style={{ width: "80px", height: "auto" }}
          />
        </div> */}

        {/* Shape 3 with bounce animation */}
        {/* <div className="it-breadcrumb-shape-3 animated-shape-2 d-none d-md-block">
          <img
            src={shapeImg3}
            alt=""
            style={{ width: "80px", height: "auto" }}
          />
        </div> */}

        {/* Content */}
        <div className="container">
          <div className="row ">
            <div className="col-md-12">
              <div className="it-breadcrumb-content z-index-3 text-center">
                <div className="it-breadcrumb-title-box">
                  <h3 className="it-breadcrumb-title">
                    {title ? title : "about us"}
                  </h3>
                </div>

                <div className="it-breadcrumb-list-wrap">
                  <div className="it-breadcrumb-list">
                    {/* Home */}
                    <span>
                      <Link to="/">home</Link>
                    </span>

                    {subtitle && (
                      <>
                        <span className="dvdr px-2">//</span>
                        {typeof subtitle === "object" ? (
                          <span>
                            <Link to={subtitle.link}>{subtitle.label}</Link>
                          </span>
                        ) : (
                          <span>{subtitle}</span>
                        )}
                      </>
                    )}

                    {/* Title */}
                    <span className="dvdr px-2">//</span>
                    <span>{title}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
